import { Divider, Flex, Text, Tooltip, Icon } from "@chakra-ui/react";
import React from "react";
import { BiInfoCircle } from "react-icons/bi";

type dataType = {
  title: string;
  value: number | string;
  option: string;
  tooltip?: string;
};

interface ExchangeStatusProps {
  data: dataType[];
}

export const ExchangeStatusWrapper = ({ data = [] }: ExchangeStatusProps) => {
  return (
    <Flex
      bg="brand.backgroundLight"
      boxShadow="0px 4px 12px rgba(53, 56, 140, 0.05)"
      borderRadius="8px"
      py="1rem"
      px={{ base: "1rem", xl: "1rem" }}
      mt="1.5rem"
      textAlign="center"
      flexDir={{ base: "column", xl: "row" }}
      justifyContent="space-around"
    >
      {data.map((item: dataType, index: number) => {
        return (
          <React.Fragment key={index}>
            <Flex
              flexGrow={1}
              flexDir={{ base: "row", xl: "column" }}
              justifyContent="space-between"
              alignItems="center"
              gap="1rem"
              py={{ base: "0.5rem", xl: "0" }}
            >
              <Flex alignItems="center" gap="0.3rem">
                <Text fontSize="14px" color="brand.textColor" fontWeight="400">
                  {item.title}
                </Text>
                {item.tooltip && (
                  <Tooltip
                    hasArrow
                    label={item.tooltip}
                    placement="top"
                    shouldWrapChildren
                  >
                    <Icon
                      as={BiInfoCircle}
                      fontSize=".9rem"
                      color="brand.textInactive"
                    />
                  </Tooltip>
                )}
              </Flex>
              <Text fontWeight="600" fontSize="1rem">
                {item.value} {item?.option && ` ${item.option}`}
              </Text>
            </Flex>
            {index < data.length - 1 && (
              <Flex
                height="32px"
                position="relative"
                top="1rem"
                display={{ base: "none", xl: "block" }}
              >
                <Divider orientation="vertical" borderColor="brand.separator" />
              </Flex>
            )}
          </React.Fragment>
        );
      })}
    </Flex>
  );
};
